import { render, staticRenderFns } from "./transfer-list.vue?vue&type=template&id=0d0ff046&scoped=true&"
import script from "./transfer-list.vue?vue&type=script&setup=true&lang=js&"
export * from "./transfer-list.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./transfer-list.vue?vue&type=style&index=0&id=0d0ff046&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ff046",
  null
  
)

export default component.exports